import { ApplicationConfig, isDevMode, LOCALE_ID } from '@angular/core';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  provideIonicAngular,
  IonicRouteStrategy,
} from '@ionic/angular/standalone';
import { provideStore } from '@ngrx/store';
import {
  routerReducer,
  provideRouterStore,
  RouterState,
} from '@ngrx/router-store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideAuth } from '@lyceo/shared/auth/feature-main';
import {
  PreloadAllModules,
  provideRouter,
  RouteReuseStrategy,
  withPreloading,
} from '@angular/router';
import { provideAlfredClient } from '@lyceo/alfred-client';
import { provideSentry } from '@techniek-team/sentry-web';
import { appRoutes } from './app.routes';
import localeNl from '@angular/common/locales/nl';
import { registerLocaleData } from '@angular/common';
import { environment } from '../environments/environment';
import { provideStorage, Drivers } from '@techniek-team/common';
import { provideApplicationStore } from '@lyceo/shared/data-access';

registerLocaleData(localeNl, 'nl');

const ALFRED_DASHBOARD_STORAGE: string = '__lyceo-alfred-dashboard';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'nl-NL' },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideRouter(appRoutes, withPreloading(PreloadAllModules)),
    provideHttpClient(withInterceptorsFromDi()),
    provideIonicAngular({
      useSetInputAPI: true,
    }),
    provideStore({
      router: routerReducer,
    }),
    provideStoreDevtools({
      maxAge: 25,
      logOnly: !isDevMode(),
      autoPause: true,
      features: {
        pause: false,
        lock: true,
      },
      connectInZone: true,
    }),
    provideRouterStore({
      routerState: RouterState.Minimal,
    }),
    provideApplicationStore(),
    provideAuth({
      oAuthConfig: environment.authConfig,
      authModuleConfig: environment.authModuleConfig,
      storagePrefix: ALFRED_DASHBOARD_STORAGE,
      initialize: true,
      setSentryUser: true,
    }),
    provideAlfredClient({
      alfredApiUrl: environment.alfredApi,
      biebApiUrl: environment.biebApi,
      production: environment.production,
      autoFocus: false,
    }),
    provideStorage({
      name: ALFRED_DASHBOARD_STORAGE,
      driverOrder: [Drivers.LocalStorage],
    }),
    provideSentry(
      {
        environment: environment.environment,
        dsn: environment.sentryDsn,
        release: environment.release,
        autoSessionTracking: true,
        enableTracing: true,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        profilesSampleRate: 0,
      },
      //withTracing(),
    ),
  ],
};
